/**
 * @flow
 */

import {
  ON_BETA_DASHBOARD_MOUNT,
  ON_BETA_DASHBOARD_MOUNT_ERROR,
  ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_STARTED,
  ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_SUCCESS,
  ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_ERROR
} from '../actions';

const initialState = {
  loading: false,
  data: {}
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {

    case ON_BETA_DASHBOARD_MOUNT:
    case ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_STARTED:
      return Object.assign({}, state, {
        loading: true
      });

    case ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_ERROR:
    case ON_BETA_DASHBOARD_MOUNT_ERROR:
      return initialState;

    case ON_BETA_DASHBOARD_FETCH_ACCOUNT_REPORT_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.payload
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/beta-dashboard/reducers/report.js